var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { DriveState } from '../../state/drive-state';
import { Store } from '@ngxs/store';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { Toast } from 'common/core/ui/toast.service';
import { DriveEntryApiService } from '../../drive-entry-api.service';
import { EntryRenamed } from '../../state/actions/events';
import { SecurityHandler } from "../../security/security-handler";
import { EncryptionHandler } from "../../security/encryption-handler";
var RenameEntryDialogComponent = /** @class */ (function () {
    function RenameEntryDialogComponent(dialogRef, store, toast, entriesApi, changeDetection) {
        this.dialogRef = dialogRef;
        this.store = store;
        this.toast = toast;
        this.entriesApi = entriesApi;
        this.changeDetection = changeDetection;
        this.entryName = new FormControl();
        this.loading = new BehaviorSubject(false);
        this.errors = {};
    }
    RenameEntryDialogComponent.prototype.ngOnInit = function () {
        this.entry = this.store.selectSnapshot(DriveState.selectedEntries)[0];
        this.entryName.setValue(this.entry.name);
    };
    RenameEntryDialogComponent.prototype.confirm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newName, securityHandler, keyDec, encryptionHandler, newNameEnc;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newName = this.entryName.value;
                        // entry name was not changed
                        if (newName === this.entry.name) {
                            return [2 /*return*/, this.close()];
                        }
                        this.loading.next(true);
                        securityHandler = new SecurityHandler();
                        return [4 /*yield*/, securityHandler.decryptKeyString(this.entry.key)];
                    case 1:
                        keyDec = _a.sent();
                        encryptionHandler = EncryptionHandler.getEncryptor();
                        encryptionHandler.resetIV();
                        return [4 /*yield*/, encryptionHandler.setKey(keyDec)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, encryptionHandler.encryptBlob(new Blob([newName]))];
                    case 3:
                        newNameEnc = _a.sent();
                        newNameEnc = btoa(String.fromCharCode.apply(null, new Uint8Array(newNameEnc)));
                        return [2 /*return*/, this.entriesApi.update(this.entry.id, { name: newNameEnc })
                                .pipe(finalize(function () { return _this.loading.next(false); }))
                                .subscribe(function () {
                                _this.setErrors();
                                // TODO: decrypt in state, pass encrypted name here
                                _this.store.dispatch(new EntryRenamed(_this.entry, newName));
                                _this.close();
                            }, function (response) { return _this.setErrors(response); })];
                }
            });
        });
    };
    RenameEntryDialogComponent.prototype.setErrors = function (response) {
        this.loading.next(false);
        this.errors = response ? response.messages : {};
        this.changeDetection.detectChanges();
    };
    RenameEntryDialogComponent.prototype.close = function () {
        this.dialogRef.close();
    };
    return RenameEntryDialogComponent;
}());
export { RenameEntryDialogComponent };
